import { useId } from 'react'
import IconContainer from '@/components/IconContainer'

export default function IconColorWallet(props) {
  const id = useId()
  return (
    <IconContainer
      {...props}
      width="41"
      height="40"
      ariaLabel="Wallet Icon"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        fill={`url(#${id})`}
        stroke={`url(#${id})`}
        strokeWidth="0.3"
        d="M3 6.85151C3 5.18241 4.34467 3.81428 6.05248 3.68777L6.31126 3.67822H29.7758C31.2229 3.67822 32.4112 4.73998 32.5387 6.09493L32.5501 6.33692L32.5489 9.97505L32.9897 9.97538C35.3047 9.97538 37.1989 11.7019 37.3468 13.8847L37.356 14.1598L37.3547 18.8191L37.6269 18.8192C38.8316 18.8192 39.8225 19.6966 39.9417 20.821L39.9537 21.049V25.1096C39.9537 26.2641 39.0381 27.2138 37.8648 27.3279L37.6269 27.3395L37.3547 27.3389L37.356 32.1379C37.356 34.3565 35.5544 36.1718 33.2768 36.3134L32.9897 36.3223H7.36634C5.05133 36.3223 3.15712 34.5958 3.00929 32.413L3 32.1379V6.85151ZM5.3277 12.0287L5.32683 32.1379C5.32683 33.1454 6.12226 33.9749 7.14411 34.081L7.36634 34.0924H32.9897C34.041 34.0924 34.9065 33.3302 35.0172 32.3509L35.0292 32.1379L35.0279 27.3389L29.1862 27.3395C27.9815 27.3395 26.9906 26.462 26.8714 25.3376L26.8594 25.1096V21.049C26.8594 19.8945 27.775 18.9449 28.9483 18.8307L29.1862 18.8192L35.0279 18.8191L35.0292 14.1598C35.0292 13.1523 34.2338 12.3228 33.2119 12.2167L32.9897 12.2053H7.36634L7.36549 12.1706L6.31126 12.171C5.96877 12.171 5.63843 12.1212 5.3277 12.0287ZM37.6269 20.5344H29.1862C28.932 20.5344 28.7191 20.7037 28.6634 20.931L28.6493 21.049V25.1096C28.6493 25.3532 28.8259 25.5572 29.0631 25.6106L29.1862 25.6242H37.6269C37.8811 25.6242 38.094 25.4549 38.1496 25.2276L38.1638 25.1096V21.049C38.1638 20.8054 37.9872 20.6014 37.75 20.548L37.6269 20.5344ZM29.7758 5.9081H6.31126C5.82194 5.9081 5.41601 6.25023 5.33971 6.69848L5.32683 6.85151V9.01702C5.33667 9.47794 5.69124 9.85776 6.1535 9.92911L6.31126 9.94116L30.2221 9.94075L30.2233 6.33692C30.2233 6.17452 30.1291 6.03321 29.9902 5.96042L29.8784 5.91943L29.7758 5.9081Z"
      />
      <defs>
        <linearGradient
          id={id}
          x1="39.9537"
          y1="22.6235"
          x2="3.00006"
          y2="22.6696"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2b6aff" />
          <stop offset="1" stopColor="#39d0d8" />
        </linearGradient>
      </defs>
    </IconContainer>
  )
}
